import { TApplicationState } from '../../types/referrer/store';

export const selectIsWebview = (state: TApplicationState) => state.page.isWebview;

export const selectPageModal = (state: TApplicationState) => state.page.modals;

export const selectIsStickyScrollBtnVisible = (state: TApplicationState) => state.page.stickyScrollBtnVisible;

export const selectReferralLinkFallbackModal = (state: TApplicationState) => state.page.referralLinkFallbackModal;
